import { type RouteConfiguration, SEARCH_CONTEXT } from "@/search/routes";
import type { Permission } from "@/types/account";
import type { Newsletter } from "@/types/newsletter";

export const shouldShow = (
  child: RouteConfiguration,
  permissions: Permission["permissions"],
  newsletter: Newsletter | null
) => {
  if (newsletter === null) {
    return false;
  }
  if (child.feature) {
    if (!newsletter.enabled_features.includes(child.feature)) {
      return false;
    }
  }
  if (child.permission) {
    if (
      !(
        permissions[child.permission] === "read" ||
        permissions[child.permission] === "write"
      )
    ) {
      return false;
    }
  }
  return true;
};

const determineActiveNavigation = (
  permissions: Permission["permissions"],
  newsletter: Newsletter
): RouteConfiguration[] => {
  return [
    SEARCH_CONTEXT["/subscribers"],
    SEARCH_CONTEXT["/emails"],
    SEARCH_CONTEXT["/tags"],
    SEARCH_CONTEXT["/automations"],
    SEARCH_CONTEXT["/comments"],
    SEARCH_CONTEXT["/surveys"],
    SEARCH_CONTEXT["/webhooks"],
    SEARCH_CONTEXT["/feeds"],
    SEARCH_CONTEXT["/sponsorships"],
    SEARCH_CONTEXT["/analytics"],
    SEARCH_CONTEXT["/requests"],
    SEARCH_CONTEXT["/events"],
  ].filter((item) => shouldShow(item, permissions, newsletter));
};

export { determineActiveNavigation };
